import { render } from "./StarOpenIcon.vue?vue&type=template&id=22605172&scoped=true"
const script = {}

import "./StarOpenIcon.vue?vue&type=style&index=0&id=22605172&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22605172"]])

export default __exports__